import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

// This component updates the URL in the language buttons as soon the
// React router changes URL. The language switch redirects back to it, so the query string is kept
// too, otherwise a page would lose its state in the URL when the language changes.
export function ChangeLanguageNextUrlUpdater() {
    const { pathname, search } = useLocation();

    const languageButtons = useMemo(
        () => document.querySelectorAll<HTMLInputElement>('.language-menu input[name=next]'),
        []
    );

    useEffect(() => {
        languageButtons.forEach((button) => {
            button.value = `${pathname}${search}`;
        });
    }, [pathname, search, languageButtons]);

    return null;
}
